import { fetchCurrentSubscription } from './fetch_current_subscription'
import { fetchNextBill } from './fetch_next_bill'

export const fetchCurrentSubscriptionAndNextBill = () => async (dispatch) => {
  await dispatch(fetchCurrentSubscription())
  await dispatch(fetchNextBill())
}
